const main = require('rolex_core/main');
const aiopsMain = require('layout_aiops/main');

Object.keys(aiopsMain).forEach((k) => (main[k] = aiopsMain[k]));
module.exports = main;
